import { DateRangePickerComponent } from "@syncfusion/ej2-react-calendars";
import { useFormik } from "formik";
import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  fetchGroupList,
  fetchOkrNotificationDrillDownStatsByPost,
  fetchOkrNotificationStatsByPost,
  fetchOkrUserSessionStatsByPost,
} from "../../../middleware/services/reportApi";

import { RadioButtonComponent } from "@syncfusion/ej2-react-buttons";
import { ColumnDirective, ColumnsDirective } from "@syncfusion/ej2-react-treegrid";
import { StringFilter, DateFilter } from "app/components/dataGrid/fliters";
import TreeDataGridNew from "app/components/treeDataGridNew";
import { hideLoader, showLoader } from "middleware/actions/utilityAction";
import { fetchTaxonomyTrend } from "middleware/services/cmsApi";
import { presets } from "utils";
import emptyImage from "../../../assets/images/images/empty.svg";
import { OKR_STATS_TYPE, OKR_STATS_TYPE_USER_SESSION, OKR_STATS_TYPE_NOTIFICATION, OKR_REPORT_DATE_RANGE_MAX } from "../../../constants/index";
import { isAdmin } from "../../../utilities";
import { Dropdown } from "../../components/CustomFormElements/syncFusionFormFields";
import CustomSidebar from "./SideBar";
import "./style.scss";
import * as CONSTANTS from "../../../constants/index";
import CloseIcon from "../../../assets/images/closeIcon.svg?react";
import NewPagination from "app/components/newPagination/newPagination";
import PropTypes from "prop-types";
import MultiSelectDropDown2 from "app/components/MultiSelectDropdown2";

const DateTemplate = (value) => {
  const column = value.column.field;
  return !!column && !isNaN(Date.parse(value[`${column}`])) ? <span>{formatDate(value[`${column}`])}</span> : "";
};

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: false,
    timeZone: "Asia/Kolkata", // Change the timeZone to the desired time zone
  };

  const formattedDate = new Intl.DateTimeFormat("en-IN", options).format(date);

  // Use string manipulation to capitalize "AM" and "PM"
  const capitalizedDate = formattedDate.replace(/(am|pm)/gi, (match) => match.toUpperCase()).replace(",", "");

  return capitalizedDate;
};

const SiderBarGrid = ({ onclose, fetch, showSidePanel, isNotificationDrillDownLoading }) => {
  const dispatch = useDispatch();
  const [rowData, setRowData] = useState([]);
  const showLoaderGrid = () => dispatch(showLoader());
  const hideLoaderGrid = () => dispatch(hideLoader());

  const NotificationDrillDownColumnFields = [
    {
      field: "srNo",
      headerText: "Sr. No",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "50px",
      allowFiltering: false,
      allowSorting: false,
      showInColumnChooser: true,
    },
    {
      field: "notificationTemplateName",
      headerText: "Template Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationIndustry",
      headerText: "Industry",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationSubject",
      headerText: "Notification Name (Subject)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "170px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationFrom",
      headerText: "From",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationMode",
      headerText: "Notification Mode",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationTo",
      headerText: "Recipient (Email Id/ Mo No)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "170px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationSubscriberName",
      headerText: "Subscriber Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationSentTimeStamp",
      headerText: "Sent Time Stamp",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationDeliveryTimeStamp",
      headerText: "Delivery Time Stamp",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationDeliveryStatus",
      headerText: "Delivery Status",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "130px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationBounceReason",
      headerText: "Bounce Reason",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "130px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationFirstOpenTimeStamp",
      headerText: "First Open Time Stamp",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "noOfOpens",
      headerText: "No Of Opens",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "90px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationFirstClickTimeStamp",
      headerText: "First Click Time Stamp",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationLinksClicked",
      headerText: "Links Clicked",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "110px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationNumberOfClicks",
      headerText: "No of Clicks",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "170px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationLoginTriggered",
      headerText: "Login Triggered (Yes/No)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "120px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginTime",
      headerText: "Login Timestamp",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "170px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "deviceType",
      headerText: "Device Type",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "120px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "operatingSystem",
      headerText: "Operating System",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "120px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "browser",
      headerText: "Browser",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "90px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "geoLocation",
      headerText: "Geo Location (If Available)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "notificationEmailCampaignName",
      headerText: "Email Campaign Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "170px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "trackingId",
      headerText: "Tracking ID",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "200px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      const response = await fetch(showSidePanel?.filters);
      if (response?.length > 0) setRowData(response);
    } catch (error) {
      hideLoaderGrid();
      console.error("Error fetching data:", error);
    }
  }, []);

  useEffect(() => {
    (async () => {
      showLoaderGrid();
      await fetchData();
      hideLoaderGrid();
    })();
  }, []);

  return (
    <div className="gennx-grid-client-detail-report  okr-stat-report okr-report-grid" style={{ height: "100%" }}>
      <header className="user-grid-header">
        <span className="header-text">Drill Down Report</span>
        <span
          className="closeIcon"
          onClick={() => {
            onclose();
          }}
        >
          <CloseIcon />
        </span>
      </header>
      {rowData.length > 0 && (
        <div className="gennx-grid-client-detail-report okr-report-grid-drill ">
          <TreeDataGridNew
            gridTitle="Drill Down Report"
            rowData={rowData}
            isPaging={false}
            showResetFilter={true}
            showLoader={showLoaderGrid}
            hideLoader={hideLoaderGrid}
            deleteMany={false}
            allowPagination={true}
            showExportButton={true}
            exportFileName={"Notification - Drill Down Report"}
            wrapMode="Header"
            allowTextWrap={true}
          >
            <ColumnsDirective>
              {NotificationDrillDownColumnFields.map((column) => (
                <ColumnDirective key={column?.srNo} {...column} />
              ))}
            </ColumnsDirective>
          </TreeDataGridNew>
        </div>
      )}
      {!isNotificationDrillDownLoading && !rowData?.length && (
        <div className="noKeyPlayerImage">
          <Image src={emptyImage} alt="No data available" />
          <p style={{ fontSize: "15px", fontWeight: "bold" }}>No Data Available</p>
        </div>
      )}
    </div>
  );
};

// Adding prop validation
SiderBarGrid.propTypes = {
  onclose: PropTypes.func.isRequired, // Function to close the sidebar
  fetch: PropTypes.func.isRequired, // Function to fetch data
  showSidePanel: PropTypes.func.isRequired, // Function to fetch data
  isNotificationDrillDownLoading: PropTypes.bool.isRequired, // Function to fetch data
};

const OkrReport = () => {
  const dispatch = useDispatch();
  const [selectedStatType, setSelectedStatType] = useState(OKR_STATS_TYPE?.[0]);
  const [startDate, setStartDate] = useState(moment(new Date()).subtract(6, "months").format("DD-MMM-yyyy"));
  const [endDate, setEndDate] = useState(moment(new Date()).format("DD-MMM-yyyy"));
  const [dateRange, setDateRange] = useState([moment(moment().subtract(6, "months")).toDate(), moment(moment().format("")).toDate()]);
  const [NotificationRowData, setNotificationRowData] = useState([]);
  const [UserSessionRowData, setUserSessionRowData] = useState([]);
  const [totalNotificationCount, setTotalNotificationCount] = useState(0);
  const [totalUserSessionCount, setTotalUserSessionCount] = useState(0);
  const [showSidePanel, setShowSidePanel] = useState({ flag: false, filters: [] });
  const [gridRef, setGridRef] = useState(null);
  const [industryArray, setIndustryArray] = useState([]);
  const [groupDataSource, setGroupDataSource] = useState([]);
  const [isNotificationStatLoading, setIsNotificationStatLoading] = useState(false);
  const [isUserStatLoading, setIsUserStatLoading] = useState(false);
  const [notificationStatPageSize, setNotificationStatPageSize] = useState(10);
  const [userSessionPageSize, setuserSessionPageSize] = useState(10);
  const [isNotificationDrillDownLoading, setIsNotificationDrillDownLoading] = useState(true);

  const sidebarRef = useRef(null);
  const showLoaderGrid = () => dispatch(showLoader());
  const hideLoaderGrid = () => dispatch(hideLoader());

  const initialState = {
    reportIndustry: "All",
    reportCreatedOn: "",
    reportGroup: [],
    reportNotificationMode: "All",
  };

  const formik = useFormik({
    initialValues: {
      ...initialState,
    },
  });

  const toggleSidebar = useCallback(
    (value) => {
      let filters = [];
      let dateFrom = dateRange?.[0];
      let dateTo = dateRange?.[1];

      let columnFieldName = value?.column?.field;
      let industry = value?.industryHidden;
      let notificationName = value?.notification ?? "";

      let formattedFromDate, formattedToDate;

      if (dateFrom) {
        const localFrom = new Date(dateFrom);
        // Construct a UTC date using the local date's year, month, and day
        formattedFromDate = new Date(Date.UTC(localFrom.getFullYear(), localFrom.getMonth(), localFrom.getDate(), 0, 0, 0, 0)).toISOString();
      }

      if (dateTo) {
        const localTo = new Date(dateTo);
        // Construct a UTC date using the local date's year, month, and day
        formattedToDate = new Date(Date.UTC(localTo.getFullYear(), localTo.getMonth(), localTo.getDate(), 23, 59, 59, 0)).toISOString();
      }

      let userGroup = (formik?.values?.reportGroup ?? []).filter((item) => item !== "All");

      filters.push(["notificationSentTimeStamp", "gte", formattedFromDate]);
      filters.push(["notificationSentTimeStamp", "lte", formattedToDate]);

      if (industry) {
        filters.push(["notificationIndustry", "eq", industry]);
      }
      if (notificationName) {
        filters.push(["notificationEmailCampaignName", "eq", notificationName]);
      }

      if (userGroup && userGroup.length > 0) {
        filters.push(["notificationUserGroup", "in", userGroup]);
      }

      if (columnFieldName == "contentClicks") {
        filters.push(["notificationLinksClicked", "gt", 0]);
      } else if (columnFieldName == "deliveredUsers") {
        filters.push(["notificationDeliveryStatus", "eq", CONSTANTS.DELIVERED]);
      } else if (columnFieldName == "analystClicks") {
        filters.push(["notificationAskYourAnalystClicked", "gt", 0]);
      } else if (columnFieldName == "loginUsers") {
        filters.push(["notificationLoginTriggered", "eq", CONSTANTS.YES]);
      }
      if (sidebarRef.current) {
        sidebarRef.current.hide();
      }

      setShowSidePanel((prev) => ({ flag: !prev?.flag, filters: filters }));
    },
    [dateRange, startDate, endDate, formik]
  );

  const recordsTemplate = (value) => {
    const a = value[`${value.column.field}`];
    let isIndustryOrTotalPresent = value?.industry;

    return a ? (
      <button
        tabIndex="0"
        className={`${isIndustryOrTotalPresent ? "span-link-color-with-industry-total" : "span-link-color"}`}
        style={{ border: "0px", margin: "0px", padding: "0px" }}
        onClick={() => toggleSidebar(value)}
        onKeyDown={() => {}}
      >
        {a}
      </button>
    ) : (
      <span>{a}</span>
    );
  };

  const fetchNotificationStatData = async (params, params1) => {
    try {
      setIsNotificationStatLoading(true);
      let param = params ?? params1;
      let dateFrom = dateRange?.[0];
      let dateTo = dateRange?.[1];
      let filters = [];

      let formattedFromDate, formattedToDate;

      if (dateFrom) {
        const localFrom = new Date(dateFrom);
        // Construct a UTC date using the local date's year, month, and day
        formattedFromDate = new Date(Date.UTC(localFrom.getFullYear(), localFrom.getMonth(), localFrom.getDate(), 0, 0, 0, 0)).toISOString();
      }

      if (dateTo) {
        const localTo = new Date(dateTo);
        // Construct a UTC date using the local date's year, month, and day
        formattedToDate = new Date(Date.UTC(localTo.getFullYear(), localTo.getMonth(), localTo.getDate(), 23, 59, 59, 0)).toISOString();
      }

      let userGroup = (formik?.values?.reportGroup ?? []).filter((item) => item !== "All");

      if (userGroup?.length > 0) {
        filters.push(["notificationUserGroup", "in", (formik?.values?.reportGroup ?? []).filter((item) => item !== "All")]);
      }
      if (formik?.values?.reportNotificationMode && formik?.values?.reportNotificationMode !== "All") {
        filters.push(["notificationMode", "eq", formik?.values?.reportNotificationMode]);
      }
      if (formik?.values?.reportIndustry && formik?.values?.reportIndustry !== "All") {
        filters.push(["industryHidden", "eq", formik?.values?.reportIndustry]);
      }
      filters.push(["notificationSentTimeStamp", "gte", formattedFromDate]);
      filters.push(["notificationSentTimeStamp", "lte", formattedToDate]);

      let res = await fetchOkrNotificationStatsByPost({ filters, limit: param?.limit ?? notificationStatPageSize, skip: param?.skip ?? 0 });
      let newResWithSrNo = (res?.data?.data ?? []).map((item, key) => ({ ...item, srNo: (param?.skip ?? 0) + key + 1 }));
      setNotificationRowData(newResWithSrNo);
      setTotalNotificationCount(res?.data?.totalCount ?? 0);
      setIsNotificationStatLoading(false);
      return res;
    } catch (err) {
      hideLoaderGrid();
      console.log("err", err);
    }
  };

  const fetchUserSessionStatData = async (params, params1) => {
    try {
      let param = params ?? params1;
      setIsUserStatLoading(true);
      let dateFrom = dateRange?.[0];
      let dateTo = dateRange?.[1];
      let formattedFromDate, formattedToDate;

      if (dateFrom) {
        const localFrom = new Date(dateFrom);
        // Construct a UTC date using the local date's year, month, and day
        formattedFromDate = new Date(Date.UTC(localFrom.getFullYear(), localFrom.getMonth(), localFrom.getDate(), 0, 0, 0, 0)).toISOString();
      }

      if (dateTo) {
        const localTo = new Date(dateTo);
        // Construct a UTC date using the local date's year, month, and day
        formattedToDate = new Date(Date.UTC(localTo.getFullYear(), localTo.getMonth(), localTo.getDate(), 23, 59, 59, 0)).toISOString();
      }

      let filters = [];

      let userGroup = (formik?.values?.reportGroup ?? []).filter((item) => item !== "All");
      if (userGroup?.length > 0) {
        filters.push(["userGroup", "in", (formik?.values?.reportGroup ?? []).filter((item) => item !== "All")]);
      }
      let analysisPeriodFilter = [];
      analysisPeriodFilter.push(["firstActionTimestamp", "gte", formattedFromDate]);
      analysisPeriodFilter.push(["lastActionTimestamp", "lte", formattedToDate]);
      let res = await fetchOkrUserSessionStatsByPost(analysisPeriodFilter, {
        filters,
        limit: param?.limit ?? userSessionPageSize,
        skip: param?.skip ?? 0,
      });
      let newResWithSrNo = (res?.data?.data ?? []).map((item, key) => {
        let loginIsoDate = item?.loginTime ?? new Date();
        let momentObj = moment(loginIsoDate);
        // Get the day of the month
        let day = momentObj.date();

        // Get the year
        let year = momentObj.year();
        return { ...item, srNo: (param?.skip ?? 0) + key + 1, loginYear: year, loginDay: day };
      });
      setUserSessionRowData(newResWithSrNo);
      setTotalUserSessionCount(res?.data?.totalCount ?? newResWithSrNo?.length ?? 0);
      setIsUserStatLoading(false);
      return res;
    } catch (err) {
      setIsUserStatLoading(false);
    }
  };

  const fetchNotificationDrillDownData = async (drillDownFilters = []) => {
    try {
      setIsNotificationDrillDownLoading(true);
      let filters = [];
      filters.push(...drillDownFilters);
      let res = await fetchOkrNotificationDrillDownStatsByPost({ filters });
      let newResWithSrNo = (res?.data?.data ?? []).map((item, key) => ({ ...item, srNo: key + 1 }));
      setIsNotificationDrillDownLoading(false);
      return newResWithSrNo;
    } catch (err) {}
  };

  const handleStatTypeChange = async (e) => {
    if (e?.value) {
      setSelectedStatType(e?.value);
    } else {
      setSelectedStatType(OKR_STATS_TYPE?.[0]);
    }
    let selectedStat = e?.value?.value;
    if (selectedStat == OKR_STATS_TYPE_NOTIFICATION) {
      setUserSessionRowData([]);
    } else if (selectedStat == OKR_STATS_TYPE_USER_SESSION) {
      setNotificationRowData([]);
    }
  };

  let userCompetencyIndustry =
    localStorage.getItem("userCompetencyIndustry") !== "null" ? JSON.parse(localStorage.getItem("userCompetencyIndustry")) : [];

  /**
   * Return Industry data based on user competency.
   *
   * @returns {Object[]}  - "Return the industry data".
   */
  const industrySource = useMemo(() => {
    if (isAdmin()) {
      const filterArray = industryArray.map((industry) => ({ label: industry.trendName, value: industry.trendName }));
      filterArray.unshift({ label: "All", value: "All" });
      return filterArray;
    }
    const uniqueIndustryNames = new Set();
    const industryList = userCompetencyIndustry
      .filter((industry) => {
        const industryName = industry.industryName;
        return !uniqueIndustryNames.has(industryName) && uniqueIndustryNames.add(industryName);
      })
      .map(({ industryName }) => ({ label: industryName, value: industryName }));
    industryList.unshift({ label: "All", value: "All" });
    return industryList;
  }, [userCompetencyIndustry, industryArray]);

  /**
   * Fetches groups data for dropdown datasource.
   *
   * @returns {Promise<Object[]>} - Returns a promise that resolves to an array of groups objects.
   */
  const fetchGroups = useCallback(async () => {
    try {
      const response = await fetchGroupList();
      if (response?.data?.data) {
        setGroupDataSource(response.data.data);
        let params = {
          fields: ["id", "trendName"],
          filters: [["trendParentId", "eq", 0]],
          sort: "trendName:asc",
        };
        const result = await fetchTaxonomyTrend(params);
        if (result?.data?.data) {
          setIndustryArray(result.data.data);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  const groupDataSourceList = useMemo(() => {
    let groupData = groupDataSource?.map((group) => {
      return group.groupName;
    });
    return groupData;
  }, [groupDataSource]);

  useEffect(() => {
    formik.setFieldValue(
      "reportGroup",
      groupDataSource.map((item) => item?.groupName)
    );
  }, [groupDataSource]);

  const notificationModeDataSource = useMemo(() => {
    return [
      { label: "All", value: "All" },
      { label: "Email", value: "Email" },
      { label: "WhatsApp", value: "WhatsApp" },
    ];
  });

  const rowDataBound = (args) => {
    if (args.data.level == 0) {
      args.row.childNodes[0].style.fontWeight = "600";
    }
    (args?.row?.childNodes[0]).style.fontSize = "14px";
    (args?.row?.childNodes[0]).style.textAlign = "left";
  };

  const getGridRef = (gridRefData) => {
    setGridRef(gridRefData);
  };

  const handleCreated = () => {
    if (gridRef?.current) {
      gridRef.current.grid.columnChooserSettings.operator = "contains";
    }
  };

  const NotificationStatsColumnFields = [
    {
      field: "industry",
      headerText: "Industry",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Center",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "notification",
      headerText: "Notification",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Center",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "applicableUsers",
      headerText: "Application Number of Users",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      template: recordsTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "deliveredUsers",
      headerText: "Delivered-Number of Users",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      template: recordsTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "contentClicks",
      headerText: "Clicks on Content-Number of Users",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      template: recordsTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "analystClicks",
      headerText: "Clicks on Content-Ask Your Analyst",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      template: recordsTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
    {
      field: "loginUsers",
      headerText: "Login on Platform-Number of Users",
      type: "Number",
      textAlign: "Center",
      headerTextAlign: "Left",
      template: recordsTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
      width: "70px",
    },
  ];

  const userSessionColumnFields = [
    {
      field: "srNo",
      headerText: "Sr No.",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "50px",
      allowFiltering: false,
      allowSorting: false,
      showInColumnChooser: true,
    },
    {
      field: "userEmail",
      headerText: "User Email ID",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "220px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "userName",
      headerText: "User Name",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "userGroup",
      headerText: "Group",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "userCompany",
      headerText: "Company",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "subscriptionType",
      headerText: "Subscription Type",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "userIndustry",
      headerText: "Industry",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginTime",
      headerText: "Login Time",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "180px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "logoutTime",
      headerText: "Logout Time (If Applicable)",
      type: "Date",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "180px",
      filterTemplate: DateFilter,
      template: DateTemplate,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginMonth",
      headerText: "Month of Login",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginYear",
      headerText: "Year  of Login",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginDay",
      headerText: "Day of Login",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "qtrOfLogin",
      headerText: "Qtr of Login",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "sessionDuration",
      headerText: "Session Duration (Min.)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "deviceType",
      headerText: "Device Type",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "operatingSystem",
      headerText: "Operating System",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "150px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "browser",
      headerText: "Browser",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "100px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "geoLocation",
      headerText: "Geo Location (If Available)",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "140px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
    {
      field: "loginSource",
      headerText: "Login Source",
      type: "String",
      textAlign: "Left",
      headerTextAlign: "Left",
      width: "130px",
      filterTemplate: StringFilter,
      allowFiltering: true,
      allowSorting: true,
      showInColumnChooser: true,
    },
  ];

  const handleSearch = async () => {
    let selectedStat = selectedStatType?.value;
    if (selectedStat == OKR_STATS_TYPE_NOTIFICATION) {
      setNotificationRowData([]);
      await fetchNotificationStatData();
    } else if (selectedStat == OKR_STATS_TYPE_USER_SESSION) {
      setUserSessionRowData([]);
      await fetchUserSessionStatData();
    }
  };

  const handleReset = () => {
    window.location.reload();
  };

  useEffect(() => {
    (async () => {
      await fetchGroups();
    })();
  }, []);

  useEffect(() => {
    let startDate = moment().subtract(6, "months");
    let endDate = moment().format("");
    setStartDate(moment(startDate).format("DD-MMM-yyyy"));
    setEndDate(moment(endDate).format("DD-MMM-yyyy"));
    let dateRangeStart = moment(startDate).toDate();
    let dateRangeEnd = moment(endDate).toDate();
    setDateRange([dateRangeStart, dateRangeEnd]);
  }, []);

  useEffect(() => {
    if (isUserStatLoading || isNotificationStatLoading) {
      showLoaderGrid();
    } else {
      hideLoaderGrid();
    }
  }, [isNotificationStatLoading, isUserStatLoading]);

  const isSearchDisabled = useMemo(() => {
    return formik?.values?.reportGroup?.length > 0 ? false : true;
  }, [formik.values.reportGroup]);

  return (
    <div className="px-3 grid-bg-white data-report-container">
      <div className="col-md-12 rounded-bottom nopadding p-0 bg-white">
        <div className="row p-3 okr-stat-type">
          {OKR_STATS_TYPE.map((item) => (
            <div className="mr-4" key={item.label}>
              <RadioButtonComponent
                label={item.label}
                name="default"
                change={handleStatTypeChange}
                checked={selectedStatType.label == item?.label}
                value={item}
                cssClass="e-large"
              />
            </div>
          ))}
        </div>
        <div className="row mt-2 grid-cols-12 mb-2 ">
          <div className={`col-md-2 col-lg-2 pr-0 `}>
            <Dropdown
              formik={formik}
              enabled={selectedStatType.value !== OKR_STATS_TYPE_USER_SESSION}
              placeholder="Industry"
              required={"required"}
              id="reportIndustry"
              name="reportIndustry"
              fields={{ text: "label", value: "value" }}
              value={formik.values.reportIndustry}
              dataSource={industrySource}
            />
          </div>
          <div className="col-md-3 col-lg-3  pr-0">
            <DateRangePickerComponent
              placeholder={selectedStatType.value == OKR_STATS_TYPE_USER_SESSION ? "Date Range" : "Created On"}
              cssClass="e-outline analyst-query-datepicker okr-report-datepicker"
              openOnFocus={true}
              showClearButton={false}
              format="dd MMM yyyy"
              separator="to"
              floatLabelType="Auto"
              startDate={startDate}
              endDate={endDate}
              onChange={(e) => {
                try {
                  if (e.value) {
                    setDateRange(e.value);
                    let startDate = e.value?.[0];
                    let endDate = e.value?.[1];
                    setStartDate(moment(startDate).format("DD-MMM-yyyy"));
                    setEndDate(moment(endDate).format("DD-MMM-yyyy"));
                  }
                } catch (err) {
                  console.log("err ", err);
                }
              }}
              autoComplete="off"
              max={new Date()}
              maxDays={OKR_REPORT_DATE_RANGE_MAX}
              strictMode={true}
              presets={presets}
            />
          </div>
          <div className="col-md-2  col-lg-2 pt-md-0 pt-sm-4  pr-0 ">
            <MultiSelectDropDown2
              labelText="Group*"
              selectedData={formik.values.reportGroup}
              setSelectedData={(value) => {
                formik.setFieldValue(
                  "reportGroup",
                  value.map((item) => item)
                );
              }}
              width={235}
              height={40}
              dataSource={groupDataSourceList}
              sx={{
                "@media (max-width:1440px) and (min-width:1366px)": {
                  width: 205,
                },
                "@media (max-width:1280px)": {
                  width: 190,
                },
                "@media (max-width:1279px) and (min-width:1000px)": {
                  width: 140,
                },
              }}
            />
            <div
              className="text-danger"
              style={{
                display: isSearchDisabled === true ? "block" : "none",
              }}
              role="alert"
            >
              <small>{isSearchDisabled === true ? "Group is required" : ""}</small>
            </div>
          </div>
          <div className="col-md-5  col-lg-5 row pl-4  pr-0">
            <div className={` mr-2 w-25 okr-report-ddn `}>
              <Dropdown
                key={selectedStatType?.value}
                enabled={selectedStatType.value !== OKR_STATS_TYPE_USER_SESSION}
                formik={formik}
                placeholder="Notification Mode"
                required={"required"}
                id="reportNotificationMode"
                name="reportNotificationMode"
                fields={{ text: "label", value: "value" }}
                value={formik.values.reportNotificationMode}
                dataSource={notificationModeDataSource}
              />
            </div>
            <div className="pl-2 gap-2">
              <button
                type="button"
                key={formik.values.reportGroup}
                onClick={handleSearch}
                className="search-btn px-4 btn btn-primary mr-2"
                tabIndex="-1"
                disabled={isSearchDisabled}
              >
                Search
              </button>
            </div>
            <div>
              <button type="reset" onClick={handleReset} className="btn btn-outline-dark px-4 ml-2 md:mt-2">
                Reset
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="gennx-grid-client-detail-report okr-report-grid notification-stat">
        {selectedStatType.value !== OKR_STATS_TYPE_USER_SESSION && NotificationRowData?.length > 0 && (
          <TreeDataGridNew
            gridTitle="Notification Report"
            rowData={NotificationRowData}
            isPaging={false}
            showResetFilter={true}
            deleteMany={false}
            showLoader={showLoaderGrid}
            hideLoader={hideLoaderGrid}
            allowPagination={false}
            showExportButton={true}
            exportFileName={"Notification Report"}
            rowDataBound={rowDataBound}
            getGridRef={getGridRef}
            created={handleCreated}
            allowTextWrap={true}
            wrapMode="Header"
          >
            <ColumnsDirective>
              {NotificationStatsColumnFields.map((column) => (
                <ColumnDirective key={column?.field} {...column} />
              ))}
            </ColumnsDirective>
          </TreeDataGridNew>
        )}
        {selectedStatType.value == OKR_STATS_TYPE_USER_SESSION && UserSessionRowData?.length > 0 && (
          <TreeDataGridNew
            gridTitle="User Session Report"
            rowData={UserSessionRowData}
            isPaging={false}
            showResetFilter={true}
            deleteMany={false}
            showLoader={showLoaderGrid}
            hideLoader={hideLoaderGrid}
            allowPagination={false}
            showExportButton={true}
            exportFileName={"User Session Report"}
            rowDataBound={rowDataBound}
            getGridRef={getGridRef}
            created={handleCreated}
            wrapMode={"Header"}
          >
            <ColumnsDirective>
              {userSessionColumnFields.map((column) => (
                <ColumnDirective key={column?.field} {...column} />
              ))}
            </ColumnsDirective>
          </TreeDataGridNew>
        )}
        {selectedStatType.value === OKR_STATS_TYPE_NOTIFICATION && !isNotificationStatLoading && !NotificationRowData?.length && (
          <div className="noKeyPlayerImage">
            <Image src={emptyImage} alt="No data available" />
            <p style={{ fontSize: "15px", fontWeight: "bold" }}>No Data Available</p>
          </div>
        )}
        {selectedStatType.value === OKR_STATS_TYPE_USER_SESSION && !isUserStatLoading && !UserSessionRowData?.length && (
          <div className="noKeyPlayerImage">
            <Image src={emptyImage} alt="No data available" />
            <p style={{ fontSize: "15px", fontWeight: "bold" }}>No Data Available</p>
          </div>
        )}
        {selectedStatType.value !== OKR_STATS_TYPE_USER_SESSION && (
          <div style={{ visibility: NotificationRowData?.length > 0 && !isNotificationStatLoading ? "visible" : "hidden" }}>
            <NewPagination
              rowData={NotificationRowData}
              allowPagination={true}
              showLoader={showLoaderGrid}
              hideLoader={hideLoaderGrid}
              totalCount={totalNotificationCount}
              setRowData={setNotificationRowData}
              fetch={fetchNotificationStatData}
              defaultPageView={CONSTANTS.DEFAULTANALYSTREPORTPAGEVIEW}
              pageSizeProp={notificationStatPageSize}
              setPageSizeProp={setNotificationStatPageSize}
            />
          </div>
        )}
        {selectedStatType.value == OKR_STATS_TYPE_USER_SESSION && (
          <div style={{ visibility: UserSessionRowData?.length > 0 && !isUserStatLoading ? "visible" : "hidden" }}>
            <NewPagination
              rowData={UserSessionRowData}
              allowPagination={true}
              showLoader={showLoaderGrid}
              hideLoader={hideLoaderGrid}
              totalCount={totalUserSessionCount}
              setRowData={setNotificationRowData}
              fetch={fetchUserSessionStatData}
              defaultPageView={CONSTANTS.DEFAULTANALYSTREPORTPAGEVIEW}
              pageSizeProp={userSessionPageSize}
              setPageSizeProp={setuserSessionPageSize}
            />
          </div>
        )}
      </div>

      {showSidePanel?.flag && (
        <CustomSidebar sidebarRef={sidebarRef} isOpen={showSidePanel?.flag}>
          <SiderBarGrid
            onclose={toggleSidebar}
            fetch={(filters) => fetchNotificationDrillDownData(filters)}
            showSidePanel={showSidePanel}
            isNotificationDrillDownLoading={isNotificationDrillDownLoading}
          />
        </CustomSidebar>
      )}
    </div>
  );
};

export default OkrReport;
